module.exports = __webpack_public_path__ + "img/03.daf34a78.png";